import React, { memo } from "react"
import PropTypes from "prop-types"
import PageNavigation from "./page-navigation"

const ContactNav = ({ navState, buttonClick, lang = "de" }) => {
  const navNames = require("../data/contact.json").navigation
  return (
    <PageNavigation navClasses="contact-nav">
      <button
        className={`btn mr-5${navState === "Berlin" ? " font-bold" : ""}`}
        onClick={() => buttonClick("Berlin")}
      >
        {navNames[lang][0]}
      </button>
      <button
        className={`btn${navState !== "Berlin" ? " font-bold" : ""}`}
        onClick={() => buttonClick("Shanghai")}
      >
        {navNames[lang][1]}
      </button>
    </PageNavigation>
  )
}

ContactNav.propTypes = {
  navState: PropTypes.string,
  buttonClick: PropTypes.func,
  lang: PropTypes.string,
}

export default memo(ContactNav)
